import { DOMFactory } from "./interfaces";

export class DOMFactoryController implements DOMFactory {

    createInput(): HTMLInputElement {
        const newLocationField = document.createElement('input');
        newLocationField.type = 'text';
        newLocationField.name = '_job_multi_location[]';
        newLocationField.classList.add('jobtek-multi-location-field', 'jmfe-autocomplete-field', 'jmfe-input-autocomplete', 'input-autocomplete', 'autocomplete-_job_multi_location' ,'pac-target-input');
        newLocationField.placeholder = 'np. Puławska 13, Warszawa, Polska';

        return newLocationField;
    }

    createInputWithValue(value: string): HTMLInputElement {
        const newLocationField = this.createInput();
        newLocationField.value = value;
        return newLocationField;
    }

    createInputContainer(): HTMLSpanElement {
        const inputContainer = document.createElement('span');
        inputContainer.classList.add('jobtek-multi-location-field-container');
        return inputContainer;
    }

    createRemoveButton(): HTMLButtonElement {
        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.classList.add('jobtek-multi-location-remove', 'jmfe-autocomplete-remove', 'jmfe-input-autocomplete-remove', 'input-autocomplete-remove');
        const removeIcon = document.createElement('i');
        removeButton.appendChild(removeIcon);

        return removeButton;
    }

    getButton(): HTMLButtonElement  {
        const repeaterButton = document.querySelector('.js-jobtek-add-location') as HTMLButtonElement;
        return repeaterButton;
    }
}